<template>
    <div class="clean-norilsk" :class="{'clean-norilsk--main-page': isMainPage}">
        <banner @scroll-to="scrollTo" />

        <timeline>
            <div class="swiper-slide">
                <tl-item period="Апрель">
                    <p>Планы на&nbsp;10&nbsp;лет</p>
                    <p>Анонсированы первые планы реализации программы по&nbsp;2030 год включительно</p>
                    <z-image src="/images/clean-norilsk/tl-logo-1.svg"></z-image>
                </tl-item>
                <tl-item period="Апрель">
                    <z-key-indicator
                        name="Общий бюджет всей программы"
                        value="40"
                        value-text="млрд руб."
                        size="s"
                    />
                    <z-key-indicator
                        name="На&nbsp;закуп техники выделено"
                        value="3,4"
                        value-text="млрд руб."
                        size="s"
                    />
                    <z-key-indicator
                        name="Планируется очистить"
                        value="2&nbsp;400"
                        value-text="га&nbsp;территорий"
                        size="s"
                    />
                    <z-key-indicator
                        name="Планируется демонтировать"
                        value="500"
                        value-text="заброшенных зданий"
                        size="s"
                    />
                </tl-item>
                <tl-results is-slider title="Итоги 2021">
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Демонтировано"
                            value="108"
                            value-text="объектов"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Собрано и&nbsp;вывезено мусора"
                            value="304"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Очищено территорий"
                            value="1,4"
                            value-text="млн кв. м"
                            size="s"
                            theme="white"
                        />
                    </div>
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Собрано металлолома"
                            value="39"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Затраты на&nbsp;выполнение работ"
                            value="3,03"
                            value-text="млрд руб."
                            size="s"
                            theme="white"
                        />
                    </div>
                </tl-results>
            </div>
            <div class="swiper-slide">
                <tl-item period="Июнь">
                    <z-image src="/images/clean-norilsk/timeline-logo.svg"></z-image>
                    <p>&laquo;Чистый Норильск&raquo; назван лучшей экологической программой по&nbsp;результатам подведения итогов Национальной премии в&nbsp;области экологических технологий &laquo;Экотех-Лидер&raquo;. Премия вручается за&nbsp;достижения в&nbsp;области разработки, внедрения и&nbsp;продвижения передовых экологических технологий как важнейшего элемента повестки ESG.</p>
                </tl-item>
                <tl-item period="Октябрь">
                    <z-image src="/images/clean-norilsk/timeline-logo-3.svg"></z-image>
                    <p>Победа в&nbsp;номинации &laquo;ESG. Вывод из&nbsp;эксплуатации и&nbsp;ликвидация&raquo; на&nbsp;премии &laquo;Russian Demolition Awards&raquo;.</p>
                </tl-item>
                <tl-item period="Октябрь" image="/images/clean-norilsk/blue-cars-2022.webp">
                    <p>Создано новое подразделение по&nbsp;переработке лома черных металлов мощностью переработки до&nbsp;15-20 тонн металлолома в&nbsp;час.</p>
                </tl-item>
                <tl-item period="Декабрь" bottom-video="/upload/video/clean-norilsk-results-2022.mp4" video-title="Интервью по итогам года" bottom-image="/images/clean-norilsk/cover-video-2022.webp">
                    <p>Интервью Андрея Радунцева по&nbsp;итогам года</p>
                </tl-item>
                <tl-results is-slider title="Итоги 2022">
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Демонтировано"
                            value="154"
                            value-text="объекта"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Собрано и&nbsp;вывезено мусора"
                            value="510"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Очищено территорий"
                            value="1,8"
                            value-text="млн кв. м"
                            size="s"
                            theme="white"
                        />
                    </div>
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Собрано металлолома"
                            value="32"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Рекультивировано земель"
                            value="78,8"
                            value-text="га"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Затраты на&nbsp;выполнение работ"
                            value="5,3"
                            value-text="млрд руб."
                            size="s"
                            theme="white"
                        />
                    </div>
                </tl-results>
            </div>
            <div class="swiper-slide">
                <tl-item period="Декабрь" bottom-video="/upload/video/clean-norilsk-results-2023.mp4" video-title="Интервью по итогам года" bottom-image="/images/clean-norilsk/cover-video-2023.webp">
                    <p>Интервью Андрея Радунцева по&nbsp;итогам года</p>
                </tl-item>
                <tl-results is-slider title="Итоги 2023">
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Демонтировано"
                            value="85"
                            value-text="объектов"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Собрано и&nbsp;вывезено мусора"
                            value="187"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Очищено территорий"
                            value="809"
                            value-text="тыс. кв. м"
                            size="s"
                            theme="white"
                        />
                    </div>
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Собрано металлолома"
                            value="8,5"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Рекультивировано земель"
                            value="85,6"
                            value-text="га"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Затраты на&nbsp;выполнение работ"
                            value="3,5"
                            value-text="млрд руб."
                            size="s"
                            theme="white"
                        />
                    </div>
                </tl-results>
            </div>
            <div class="swiper-slide">
                <tl-item period="Октябрь">
                    <z-image src="/images/clean-norilsk/timeline-logo-3.svg"></z-image>
                    <p>Участие в&nbsp;5-м Международном Демонтажном Форуме России</p>
                </tl-item>
                <tl-item period="Декабрь" bottom-video="/upload/video/clean-norilsk-results-2024.mp4" video-title="Интервью по итогам года" bottom-image="/images/clean-norilsk/raduncev.webp">
                    <p>Интервью Андрея Радунцева по&nbsp;итогам года</p>
                </tl-item>
                <tl-results is-slider title="Итоги 2024">
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Демонтировано"
                            value="59"
                            value-text="объектов"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Собрано и&nbsp;вывезено мусора"
                            value="148"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Очищено территорий"
                            value="723"
                            value-text="тыс. кв. м"
                            size="s"
                            theme="white"
                        />
                    </div>
                    <div class="swiper-slide">
                        <z-key-indicator
                            name="Собрано металлолома"
                            value="13,4"
                            value-text="тыс. тонн"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Рекультивировано земель"
                            value="41,4"
                            value-text="га"
                            size="s"
                            theme="white"
                        />
                        <z-key-indicator
                            name="Затраты на&nbsp;выполнение работ"
                            value="2,8"
                            value-text="млрд руб."
                            size="s"
                            theme="white"
                        />
                    </div>
                </tl-results>
            </div>
        </timeline>

        <cn-steps ref="steps" />

        <objects-switcher/>

        <div class="container">
            <quotes-slider/>
        </div>
    </div>
</template>

<script>
import CnSteps from './components/CnSteps.vue'
import Banner from './components/Banner.vue'
import QuotesSlider from './components/QuotesSlider.vue'
import Timeline from '../Timeline/Timeline.vue'
import ObjectsSwitcher from '@/views/CleanNorilsk/views/Main/components/ObjectsSwitcher/ObjectsSwitcher.vue'

export default {
    name: 'clean-norilsk',
    components: {
        ObjectsSwitcher,
        Banner,
        QuotesSlider,
        CnSteps,
        Timeline
    },
    computed: {
        isMainPage () {
            return window.location.pathname === '/clean-norilsk/'
        }
    },
    methods: {
        scrollTo () {
            this.$refs.steps.$el.scrollIntoView({block: 'center', behavior: 'smooth'})
        }
    }
}
</script>

<style lang="scss">
.clean-norilsk {

    &--main-page {
        margin-top: -165px;

        @include breakpoint (tablet) {
            margin-top: -159px;
        }

        @media (max-width: 1148px) {
            margin-top: -80px;
        }

        @include breakpoint (v-tablet) {
            margin-top: -74px;
        }
    }

    .clean-banner {
        margin-bottom: $token-spacers-s;
        &:after {
            content: '';
            height: 62px;
            width: 100%;
            background-image: url('/images/clean-norilsk/banner-bottom-line.png');
            background-position: center left;
            background-repeat: repeat-x;
            display: block;
            position: absolute;
            bottom: 0;
            background-size: cover;

            @include breakpoint(v-tablet) {
                height: 24px;
            }

            @include breakpoint(mobile) {
                height: 20px;
            }
        }
    }

    .cn-timeline {
        padding: 0 0 $token-spacers-m;

        @include breakpoint(v-tablet) {
            padding: 0 0 $token-spacers-2-xl;
            margin-bottom: -24px;
        }

        @include breakpoint(mobile) {
            padding: 0 0 $token-spacers-2-xl;
            margin-bottom: 20px;
        }
    }

    .pseudo-slider {
        position: relative;
        padding-bottom: 207px;
        transform-style: preserve-3d;

        @include breakpoint(laptop) {
            padding-bottom: 198px;
        }

        @include breakpoint(tablet) {
            padding-bottom: 160px;
        }

        @include breakpoint(v-tablet) {
            padding-bottom: 104px;
        }

        @include breakpoint(mobile) {
            padding-bottom: 84px;
        }

        .container {
            transform: translateZ(2px);
        }

        &:after {
            content: '';
            height: 300px;
            width: 100%;
            background-image: url('/images/clean-norilsk/pseudo-slider-bottom-line.png');
            background-position: top left;
            background-repeat: repeat-x;
            display: block;
            position: absolute;
            bottom: 0;
            background-size: cover;
            transform: translateZ(0);

            @include breakpoint(v-tablet) {
                height: 120px;
            }

            @include breakpoint(mobile) {
                height: 80px;
            }
        }

        &:before {
            content: '';
            height: 55px;
            width: 100%;
            background-image: url('/images/clean-norilsk/banner-bottom-line.png');
            background-position: center left;
            background-repeat: repeat-x;
            display: block;
            position: absolute;
            bottom: -1px;
            background-size: contain;
            transform: translateZ(1px);

            @include breakpoint(laptop) {
                height: 46px;
                background-size: cover;
            }

            @include breakpoint(tablet) {
                height: 32px;
            }

            @include breakpoint(v-tablet) {
                bottom: -2px;
                height: 24px;
            }

            @include breakpoint(mobile) {
                height: 20px;
            }
        }
    }

    .cn-steps {
        position: relative;

        &:before {
            content: '';
            height: 47px;
            width: 100%;
            background-image: url('/images/clean-norilsk/timeline-bottom-line.png');
            background-position: center left;
            background-repeat: repeat-x;
            display: block;
            position: absolute;
            top: -2px;
            background-size: cover;
            z-index: 1;

            @media (min-width: 1921px) {
                background-size: contain;
            }

            @include breakpoint(v-tablet) {
                height: 24px;
            }

            @include breakpoint(mobile) {
                height: 20px;
            }
        }
    }

    .default-slider {
        margin-bottom: -5%;;
        margin-top: $token-spacers-4-xl;

        @include breakpoint(v-tablet) {
            margin-top: 104px;
        }

        @include breakpoint(mobile) {
            margin-top: $token-spacers-xl;
        }
    }
}
</style>
